var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7503_16601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 8H5",
    stroke: "#2F3D37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03048 13.8301C2.99533 13.9261 2.99045 14.0305 3.01652 14.1294C3.04258 14.2283 3.09833 14.3168 3.17625 14.383C3.25417 14.4492 3.35052 14.4899 3.4523 14.4997C3.55408 14.5094 3.65641 14.4878 3.74548 14.4376L14.2455 8.43193C14.3236 8.38869 14.3888 8.3253 14.4341 8.24836C14.4795 8.17142 14.5034 8.08374 14.5034 7.99443C14.5034 7.90511 14.4795 7.81743 14.4341 7.74049C14.3888 7.66355 14.3236 7.60017 14.2455 7.55693L3.74548 1.5663C3.65667 1.51663 3.55483 1.49524 3.45354 1.50498C3.35225 1.51473 3.25635 1.55514 3.17864 1.62083C3.10093 1.68652 3.04511 1.77435 3.01864 1.8726C2.99216 1.97085 2.9963 2.07484 3.03048 2.17068L4.99986 8.00005L3.03048 13.8301Z",
    stroke: "#224C54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7503_16601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e5f6141cf980983b0640d42a5f1380b2.svg";
export { ForwardRef as ReactComponent };